import * as React from 'react';
import { Redirect } from 'react-router-dom';
export const RedirectAs404 = () => <Redirect to={Object.assign({}, location, { state: { is404: true } })} />;
